import { gsap } from 'gsap';
import { productCardSetup, productCardEnter } from './product-card';

function collectionGridSetup(el) {
  const headerItems = el.querySelector('.collection-grid__header')?.children;
  const { children:items } = el.querySelector('.collection-grid__grid');

  if (headerItems) gsap.set(headerItems, { autoAlpha: 0, y: -10 })
  if (items) [...items].forEach(item => productCardSetup(item));
}

function collectionGridEnter(el) {
  const headerItems = el.querySelector('.collection-grid__header')?.children;
  const { children:items } = el.querySelector('.collection-grid__grid');
  
  const tl = gsap.timeline({ defaults: { duration: 1, ease: 'power2.out' } });

  if (headerItems) tl.to(headerItems, { autoAlpha: 1, y: 0, stagger: 0.3 }, 0)
  if (items) [...items].forEach((item, i) => tl.add(() => productCardEnter(item), 0.1 * i));
}

export { collectionGridSetup, collectionGridEnter };